
document.addEventListener('DOMContentLoaded', function () {


const breakPointDuoVideo = window.matchMedia("(min-width:980px)");

    document.querySelectorAll('.videoPopButtonDuo').forEach(btn => {
        btn.addEventListener('click', () => {

            const pop = btn.closest('.wp-block-plblockstt-duo-media-side-video').querySelector('.popVideos');
            const mobileVideo = pop.querySelector('.mobile video');
            const desktopVideo = pop.querySelector('.desktop video');

            let videoToPlay;
            let videoToHide;

            if (breakPointDuoVideo.matches) {
                videoToPlay = desktopVideo;
                videoToHide = mobileVideo;
            } else {
                videoToPlay = mobileVideo;
                videoToHide = desktopVideo;
            }

            pop.style.display = 'flex';
            //Hide the other one
            videoToHide.parentElement.style.display = "none";
            videoToHide.style.display = "none";
            videoToHide.currentTime = 0;
            videoToHide.pause();
            //Show the right one
            videoToPlay.style.display = "block";
            videoToPlay.parentElement.style.display = "block";
            videoToPlay.currentTime = 0;
            videoToPlay.play();
            document.body.classList.add('watching');
        });
    });


    document.querySelectorAll('.popCloseDuoVideo').forEach(btn => {
        btn.addEventListener('click', () => {
            const pop = btn.closest('.popVideos');
            //Stop and hide videos
            pop.querySelectorAll('video').forEach(video => {
                video.pause();
                video.currentTime = 0;
            });
            pop.querySelector('.mobile').style.display = 'none';
            pop.querySelector('.desktop').style.display = 'none';
            //Close the pop
            pop.style.display = "none";
            document.body.classList.remove('watching');
        });
    });



});